import React from 'react';
import PropTypes from 'prop-types';
import HoverTooltip from '@Components/HoverTooltip';
import Button from '@Components/Button';
import { TooltipConstants } from '@Components/Tooltip';
import ReactDOMServer from 'react-dom/server';
import { copySmiles, getCustomerIconAriaLabel, getCustomerSpecificMapping, trackCustomerIconClick } from './structure-utils';
import StructureToolbarCustomerIconTooltip from './StructureToolbarCustomerIconTooltip';

import './StructureToolbarCustomerIcon.scss';

export default function StructureToolbarCustomerIcon({ structure, customerInfo }) {
  const onClick = () => {
    const { label } = getCustomerSpecificMapping(customerInfo.name);
    trackCustomerIconClick(label);
    return copySmiles(structure);
  };
  const { icon, label } = getCustomerSpecificMapping(customerInfo.name);
  const tooltip = ReactDOMServer.renderToString(<StructureToolbarCustomerIconTooltip customerLabel={label} />);
  const ariaLabel = getCustomerIconAriaLabel(label) || '';
  return (
    <HoverTooltip id={TooltipConstants.ids.GlobalHover} tooltip={tooltip} theme="simple">
      <Button
        buttonConfig={{
          className: `structure-customer-icon ${icon}`,
          type: 'link',
          size: 'sm',
          e2eName: 'structure-customer-icon',
          iconOnly: true,
          ariaLabel,
        }}
        iconConfig={{
          name: icon,
          noBorder: true,
        }}
        onClick={onClick}
      />
    </HoverTooltip>
  );
}

StructureToolbarCustomerIcon.defaultProps = {
  customerInfo: {},
};

StructureToolbarCustomerIcon.propTypes = {
  structure: PropTypes.string,
  customerInfo: PropTypes.object,
};
